import { ShiftBlock } from './shift-block.model';
import { StaffRatioValue } from './staff-ratio-value.model';

export class ShiftSchedule {
    id: number;
    costCenterId: number;
    type: string;
    startHour: number;
    endHour?: number;
    blockLength: number;
    isClosed: boolean;
    isWeekday: boolean;
    isWeekend: boolean;
    isSaturday: boolean;
    isSunday: boolean;
    isValid: boolean;
    shiftBlocks: ShiftBlock[];
    publishedShiftBlocks: ShiftBlock[];
    partialShiftBlocks: ShiftBlock[];
    inactiveShiftBlocks: ShiftBlock[];
    staffRatios: StaffRatioValue[];
    shiftBlockType: ShiftBlockType;
    createdDate?: Date;
    inactiveDate?: Date;
}

export enum ShiftBlockType {
    AllWeek,
    Weekday,
    Weekend,
    Sunday,
    Saturday
}